import axios, { AxiosHeaders } from 'axios'
import buildInfo from 'src/build-info.json'

axios.defaults.baseURL = process.env.REACT_APP_API_URL
let isRefreshing = false
let refreshSubscribers = []
let refreshTokenPromise = null
axios.interceptors.request.use(
	(config) => {
		config.headers = config.headers || new AxiosHeaders()
		config.headers['Platform'] = 'CMS'
		config.headers['Version'] = buildInfo.version || ''

		const accessToken = localStorage.getItem('token')
		if ((config as any).skipAuth) {
			return config
		}
		if (accessToken && !config.headers['Authorization']) {
			let parsedToken: string
			try {
				parsedToken = JSON.parse(accessToken)
			} catch {
				parsedToken = accessToken
			}
			config.headers['Authorization'] = 'Bearer ' + parsedToken
		}
		return config
	},
	(error) => Promise.reject(error),
)
const onRefreshed = (token) => {
	refreshSubscribers.map((callback) => callback(token))
	refreshSubscribers = []
}

const addRefreshSubscriber = (callback) => {
	refreshSubscribers.push(callback)
}

const refreshToken = async () => {
	if (!isRefreshing) {
		isRefreshing = true
		try {
			const refreshToken = localStorage.getItem('refresh_token') || '""'
			const response = await axios.post('/auth/refresh', {
				refresh_token: JSON.parse(refreshToken),
			})
			if (response.data?.code === 200) {
				const newAccessToken = response.data?.results?.object?.access_token
				const newRefreshToken = response.data?.results?.object?.refresh_token
				localStorage.setItem('token', JSON.stringify(newAccessToken))
				localStorage.setItem('refresh_token', JSON.stringify(newRefreshToken))
				onRefreshed(newAccessToken)
				return newAccessToken
			}
		} catch (error) {
			console.error('Unable to refresh token', error)
			if (error?.response?.data?.code === 434) {
				localStorage.clear()
			}
			throw error
		} finally {
			isRefreshing = false
			refreshTokenPromise = null // Reset the promise after refreshing
		}
	}

	if (!refreshTokenPromise) {
		refreshTokenPromise = new Promise((resolve, _reject) => {
			addRefreshSubscriber(resolve)
		})
	}

	return refreshTokenPromise
}

axios.interceptors.response.use(
	(response) => {
		return response
	},
	async (error) => {
		const originalConfig = error.config
		if ((originalConfig as any)?.skipAuth) {
			return Promise.reject(error)
		}
		if (error?.response?.data?.code === 403) {
			try {
				const newAccessToken = await refreshToken()
				if (newAccessToken) {
					originalConfig.headers['Authorization'] = 'Bearer ' + newAccessToken
					return axios(originalConfig)
				}
			} catch (refreshError) {
				console.log('Failed to refresh token', refreshError)
				if (refreshError?.response?.data?.code === 409) {
					localStorage.clear()
				}
				return Promise.reject(refreshError)
			}
		}
		if (error?.response?.data?.code === 409) {
			localStorage.clear()
		}

		return Promise.reject(error)
	},
)

export default axios
